export { hot } from 'react-hot-loader';
export * from '../sharedDependencies';
export {
    RestaurantsContainer,
    SelectRestaurantsListContainer,
    actions as restaurantsActions,
    actionTypes as restaurantsActionTypes,
    selectors as restaurantsSelectors,
} from 'Modules/lunchie-restaurants';
export { Layout, Drawer, message as antdMessage } from 'antd';
